import {SuccessEvent} from "../../../../../../common/ts/core/http";
import {WhitelabelEvent, WhitelabelEventWithPayload} from "../../../../../../common/ts/events/Events";
import {TrovitPageData} from "../../../TrovitPageData";

interface WebPushSearchAddedPayload {
    search: TrovitPageData,
    subscription: PushSubscription,
    successEvent?: SuccessEvent,
}

export class WebPushSearchAddedEvent implements WhitelabelEventWithPayload<WebPushSearchAddedPayload> {
    payload: WebPushSearchAddedPayload;
    type: string;
    static readonly TYPE: string = 'web-push-search-added';

    constructor(payload: WebPushSearchAddedPayload) {
        this.type = WebPushSearchAddedEvent.TYPE;
        this.payload = payload;
    }
}

interface WebPushPermissionsUpdatedPayload {
    pageData: TrovitPageData,
    eventType: WebPushPermissionsEventType,
    userId?: String,
    successEvent?: SuccessEvent,
}

export enum WebPushPermissionsEventType {
    REQUEST = 'request',
    ALLOW = 'allow',
    DISALLOW = 'disallow',
    CLOSE = 'close',
}

export class WebPushPermissionsUpdatedEvent implements WhitelabelEvent {
    payload: WebPushPermissionsUpdatedPayload;
    type: string;
    static readonly TYPE: string = 'web-push-permissions-updated';

    constructor(payload: WebPushPermissionsUpdatedPayload) {
        this.type = WebPushPermissionsUpdatedEvent.TYPE;
        this.payload = payload;
    }
}
